import React from 'react';
import { message } from 'antd';
import { ErrorModel, isErrorHttp } from '../common/error';

export const isErrorPc = <T extends ErrorModel>(res: T,options:{codeKey?:keyof ErrorModel['data'],codeValue?:string,messageKey?:keyof ErrorModel['data']} = {}) => {
  const {codeKey = 'code',codeValue = 200,messageKey = 'message'  } = options
  const error = isErrorHttp(res)
  if(error.isError){
     message.error(error.message)
     return true
  }
  let businessData = res.data || {}
  if (businessData[codeKey] !== codeValue) {
    message.error(businessData[messageKey]);
    return true;
  }
  return false;
};


